import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import MarketingTextBlock from 'app/Models/Content/MarketingTextBlockData';
import ProductDescriptionItemBlockData from 'app/Models/Content/ProductDescriptionItemBlockData';
import ProductDescriptionImageBlockData from 'app/Models/Content/ProductDescriptionImageBlockData';
import {getTextWithHighlight} from 'app/utilities/highlightText';
import React, {useState, useEffect} from 'react';
import ProductDescriptionImageBlock from './ProductDescriptionImageBlock';
import HiddenStopAndStartButton from 'app/utilities/HiddenStopAndStartButton';
import SwiperCore, {Pagination, Autoplay} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import {getImageProps} from 'app/utilities/ImageProps';
import {isMobile} from 'react-device-detect';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/swiper.scss';
import TagName from 'app/Components/Shared/TagName';

SwiperCore.use([Pagination, Autoplay]);

const titleHighlight = (title: MarketingTextBlock) =>
  getTextWithHighlight({text: title.text.value, highlightText: title.highlightText.value});

const ProductDescriptionItemBlock = ({data, context}: ComponentProps<ProductDescriptionItemBlockData>) => {
  const [swiperInstence, setSwiperInstence] = useState<SwiperCore>(null);
  const [swiperIsStop, setSwiperIsStop] = useState<Boolean>(false);
  const [swiperAutoPlay, setSwiperAutoPlay] = useState('Stop');
  const images = data.images?.expandedValue?.map((image: ProductDescriptionImageBlockData) => ({
    image: getImageProps(isMobile ? (image.mobileImage?.value ? image.mobileImage : image.image) : image.image, context),
    link: image.buttonLink?.value,
    linkTitle: image.buttonLinkTitle?.value,
    isFloatingButton: image.isFloatingButton?.value,
  }));

  const isSwiper = images?.length > 1;
  const isSingle = images?.length === 1;

  useEffect(() => {
    if (swiperIsStop) {
      swiperInstence?.autoplay.stop();
      setSwiperAutoPlay('Start');
    } else {
      swiperInstence?.autoplay.start();
      setSwiperAutoPlay('Stop');
    }
  }, [swiperIsStop, swiperInstence]);

  return (
    <div className={`ProductDescriptionItemBlock ${isSwiper ? 'swiper-block' : 'block'}`}>
      <div className={`ProductDescriptionItemBlock__head ${data.isFloatingTitle?.value ? 'float-title' : ''}`}>
        {data.title.expandedValue && (
          <TagName className='ProductDescriptionItemBlock__title' tagName={data.titleHeadlineTag?.value} isTitle>
            {data.title.expandedValue && titleHighlight(data.title.expandedValue[0] as MarketingTextBlock)}
          </TagName>
        )}

        {data.subtitle.value && (
          <TagName tagName={data.subtitleHeadlineTag?.value} className='ProductDescriptionItemBlock__subtitle'>
            {data.subtitle.value}
          </TagName>
        )}
      </div>
      {isSwiper ? (
        <Swiper
          onSwiper={(swiper) => {
            setSwiperInstence(swiper);
          }}
          simulateTouch={false}
          pagination={{clickable: true}}
          className='ProductDescriptionItemBlock__swiper'
          autoplay={{
            delay: 2000,
            waitForTransition: false,
          }}
          loop>
          {images.map((props, i) => (
            <SwiperSlide key={i}>
              <ProductDescriptionImageBlock {...props} />
            </SwiperSlide>
          ))}
          <HiddenStopAndStartButton
            className=''
            onClick={() => setSwiperIsStop((prevState) => !prevState)}
            swiperAutoPlay={swiperAutoPlay}
          />
        </Swiper>
      ) : (
        isSingle && <ProductDescriptionImageBlock {...images[0]} />
      )}
    </div>
  );
};

export default ProductDescriptionItemBlock;
